import * as React from 'react'
import { SVGProps } from 'react'
const SvgVolumeMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.578 5.465c.462.222.755.69.755 1.202v18.666a1.333 1.333 0 0 1-2.166 1.042l-6.301-5.042H4.333A1.333 1.333 0 0 1 3 20v-8c0-.736.597-1.333 1.333-1.333h3.533l6.301-5.041c.4-.32.949-.383 1.41-.161ZM13.667 9.44l-4.5 3.6c-.237.19-.53.292-.834.292H5.667v5.334h2.666c.303 0 .597.103.833.292l4.5 3.6V9.441ZM19.39 9.724c.521-.52 1.366-.52 1.886 0a8.876 8.876 0 0 1 0 12.552 1.333 1.333 0 0 1-1.886-1.885 6.21 6.21 0 0 0 0-8.781 1.333 1.333 0 0 1 0-1.886Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgVolumeMedium
